import React from "react";
import Password from "../../settings/Password/Password";

const ForgotPasswordPage = () => {
  return <Password isForgotPassword />;
};

export default ForgotPasswordPage;
